/* Surcharges des skins liées à l'affichage RTL */
import {IReg, REG} from "lib/commons/registry";

export function ovrReg(reg: IReg<any>) {
	reg.overlaySkin("store-ut-browser/grid", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  .current {
		  background-position: left;
	  }
	`);

	reg.overlaySkin("store-res-grid", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  .current {
		  background-position: left;
	  }
	`);

}


